import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./HeroV3.css";

const HeroV3 = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();

  // Carousel data with images and associated text
  const carouselData = [
    {
      image: "../../../assets/images/hero-carousel-1.png",
      title: "Fresh Kenyan Produce",
      description:
        "Exporting the finest fruits and vegetables from Kenya's fertile highlands to global markets.",
    },
    {
      image: "../../../assets/images/hero-carousel-2.jpg",
      title: "Premium Kenyan Tea",
      description:
        "World-renowned tea leaves from the high-altitude plantations of Kenya, carefully selected for export.",
    },
    {
      image: "../../../assets/images/hero-carousel-3.jpg",
      title: "Quality Kenyan Coffee",
      description:
        "Rich Arabica coffee beans from the volcanic soils of Mount Kenya, roasted to perfection for export.",
    },
    {
      image: "../../../assets/images/hero-carousel-4.PNG",
      title: "Sustainable Farming",
      description:
        "Ethically sourced products from farmers practicing sustainable agriculture across Kenya.",
    },
    {
      image: "../../../assets/images/hero-carousel-5.PNG",
      title: "Global Distribution",
      description:
        "Efficient logistics network ensuring fresh delivery to over 50 countries worldwide.",
    },
  ];

  // Auto-advance carousel
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % carouselData.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [carouselData.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const goToNextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % carouselData.length);
  };

  const goToPrevSlide = () => {
    setCurrentSlide(
      (prev) => (prev - 1 + carouselData.length) % carouselData.length
    );
  };

  // Debug function to check if navigation is working
  const handleExploreClick = () => {
    // console.log("Navigating to products...");
    navigate("/products/coffee/all");
  };

  // Debug function for contact
  const handleContactClick = () => {
    // console.log("Navigating to contact...");
    navigate(`/contact`);
  };

  return (
    <section className="hero-v3">
      <div className="hero-v3-carousel">
        {carouselData.map((slide, index) => (
          <div
            key={index}
            className={`carousel-slide ${
              index === currentSlide ? "active" : ""
            }`}
            style={{ backgroundImage: `url(${slide.image})` }}
          >
            <div className="slide-overlay"></div>

            {/* Slide Content */}
            <div
              className={`slide-content ${
                index === currentSlide ? "active" : ""
              }`}
            >
              <h1 className="hero-v3-title">
                Premium <span className="text-accent-v3">Kenyan</span> Produce
                <span className="line-accent"></span>
                <span className="title-line-v3">{slide.title}</span>
              </h1>

              <p className="hero-v3-description">{slide.description}</p>

              <div className="hero-v3-actions">
                <button
                  className="btn-v3 btn-primary-v3"
                  onClick={handleExploreClick} // Use the debug function
                >
                  Explore Our Products
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5 12H19M19 12L12 5M19 12L12 19"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                <button
                  className="btn-v3 btn-secondary-v3"
                  onClick={() => navigate(`/contact`)}
                >
                  Contact for Export
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21 11.5C21 16.75 16.75 21 11.5 21C6.25 21 2 16.75 2 11.5C2 6.25 6.25 2 11.5 2"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M22 22L20 20"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M15.5 11.5C15.5 13.7091 13.7091 15.5 11.5 15.5C9.29086 15.5 7.5 13.7091 7.5 11.5C7.5 9.29086 9.29086 7.5 11.5 7.5"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Carousel Controls */}
      <div className="carousel-controls">
        <button className="carousel-prev" onClick={goToPrevSlide}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 18L9 12L15 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        <div className="carousel-indicators">
          {carouselData.map((_, index) => (
            <button
              key={index}
              className={`indicator ${index === currentSlide ? "active" : ""}`}
              onClick={() => goToSlide(index)}
            />
          ))}
        </div>

        <button className="carousel-next" onClick={goToNextSlide}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9 18L15 12L9 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>

      <div className="scroll-indicator-v3">
        <span>Scroll to explore</span>
        <div className="scroll-line-v3"></div>
      </div>
    </section>
  );
};

export default HeroV3;
